import { Icon, Tooltip, Typography } from "@/components/atoms";
import { Vehicle } from "@/redux/slices/vehicle/types";
import { VehicleTypeCell } from "./common/VehicleTypeCell";

/**
 * Initial selection for the Vehicle Type multi-select. Prefers the many-to-many
 * `vehicleTypes` array; falls back to the legacy 1-to-1 `vehicleType` for
 * vehicles served by an older API response.
 */
export const getInitialVehicleTypeUuids = (vehicle: Vehicle): string[] => {
  if (vehicle.vehicleTypes && vehicle.vehicleTypes.length > 0) {
    return vehicle.vehicleTypes.map((t) => t.uuid);
  }
  return vehicle.vehicleType ? [vehicle.vehicleType.uuid] : [];
};

/**
 * Shared "Vehicle Type" cell — see VehicleTypeCell for the display rules
 * (active types only; single type shows its name; "+N Vehicle Types" link for
 * more). Kept as a render helper so plain table-data builders can call it.
 */
export const renderVehicleTypeCell = (
  vehicle: Vehicle,
  onShowTypes?: (vehicle: Vehicle) => void,
  emptyFallback?: JSX.Element,
  singleTypeClassName?: string
): JSX.Element => (
  <VehicleTypeCell vehicle={vehicle} onShowTypes={onShowTypes} emptyFallback={emptyFallback} singleTypeClassName={singleTypeClassName} />
);

export const renderColumnHeaderWithTooltip = (label: string, tooltip: string | JSX.Element, subLabel?: string) => {
  const ColumnHeader = () => (
    <div className="flex flex-col">
      <div className="flex items-center gap-1">
        {label}
        <Tooltip content={tooltip} interactive={typeof tooltip !== "string"}>
          <Icon name="InfoCircle" size="sm" variant="Bold" className="text-neutral-dark-gray" />
        </Tooltip>
      </div>
      {subLabel && (
        <Typography variant="small-regular" className="font-normal text-neutral-dark-gray">
          {subLabel}
        </Typography>
      )}
    </div>
  );
  ColumnHeader.displayName = `ColumnHeader(${label})`;
  return ColumnHeader;
};
